<ng-container *ngIf="!(loading$ | async)">
    <ng-container *ngIf="portalId$ | async as portalId; else noPortalFound">
        <section *ngIf="intro$ | async as intro" class="background-color-nearwhite">
            <div class="container">
                <h1 [innerHTML]="intro.headline"></h1>
                <div class="large">
                    <p [innerHTML]="intro.copyText"></p>
                </div>
            </div>
        </section>
        <ng-container *ngIf="(portalVersion$ | async) === 'v2'">
            <da-portal-home></da-portal-home>
        </ng-container>
        <section *ngIf="(portalVersion$ | async) === 'v1'">
            <div class="container">
                <da-iframe [portalId]="portalId" (iframeLoaded)="scrollToTop()"></da-iframe>
            </div>
        </section>
    </ng-container>
    <ng-template #noPortalFound>
        <section>
            <div class="container">
                <h1>An error occured</h1>
                <div class="large">
                    <p *ngIf="errorMessage">{{ errorMessage }}</p>
                </div>
            </div>
        </section>
    </ng-template>
</ng-container>
